import { render, staticRenderFns } from "./CompareKey.vue?vue&type=template&id=37f3e9d2&scoped=true"
import script from "./CompareKey.vue?vue&type=script&lang=js"
export * from "./CompareKey.vue?vue&type=script&lang=js"
import style0 from "./CompareKey.vue?vue&type=style&index=0&id=37f3e9d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f3e9d2",
  null
  
)

export default component.exports